import { CreativeType, Maybe } from '../../apis/graphql/types';
import { LineItemAdType } from '../../pages/Campaigns/Form/types';

export const isKerv = (ad: Maybe<LineItemAdType> | undefined): boolean =>
  ad?.creative?.creativeType === CreativeType.Kerv;
